import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

interface HilltopAdProps {
  id?: string;
}

const AdContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  position: relative;
  min-height: 90px;
`;

/**
 * HilltopAds Component
 * Publicité HilltopAds
 */
const HilltopAd: React.FC<HilltopAdProps> = ({ id = 'hilltop-ad' }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    if (isMobile) {
      // Do not load Hilltop on mobile to avoid intrusive popups
      return;
    }

    const container = containerRef.current;

    // Créer le script HilltopAds
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function(rimsb){
        var d = document,
            s = d.createElement('script'),
            l = d.scripts[d.scripts.length - 1];
        s.settings = rimsb || {};
        s.src = "https://stale-father.com/bLX/VAs.dSGfl/0pYhW/cQ/ne/mg9/uAZxUflkkjP/TGYM4DMtzZYAyyMujBkVt/N/jigCzSNnj/IbzoMLwY";
        s.async = true;
        s.referrerPolicy = 'no-referrer';
        l.parentNode.insertBefore(s, l);
      })({})
    `;

    container.appendChild(script);

    console.log('HilltopAd loaded:', id);

    return () => {
      if (container) {
        container.innerHTML = '';
      }
    };
  }, [id]);

  return <AdContainer ref={containerRef} />;
};

export default HilltopAd;
